// The whole code is copied from VPC.
import * as React from 'react';
import { CardViewStyles } from './CardViewStyles';
import * as Layout from '../../../common/styles/Layout';

export interface ThumbnailProps {
  readonly navigateUrl?: string; // If the navigateUrl is not present, then there will be no hand cursor or onclick action
  readonly defaultImageUrl: string;
  readonly thumbnailImageUrl?: string;
  readonly imageCoverBackground?: boolean;
  readonly name?: string;
  readonly decorate?: boolean;
  readonly useBase64EncodedImage?: boolean; // Use a base64 encoded svg data URI instead of an image
  readonly centeredText?: string; // text to be rendered at the center of thumbnail
  readonly ariaLabel?: string; // aria label for the thumbnail link
  onResultItemSelected: () => void;
}

export interface ThumbnailState {
  readonly loadThumbnailImage: boolean;
}

export const ThumbnailTestID = 'Thumbnail';
export const ThumbnailOverlayTestID = 'ThumbnailOverlay';

const CARD_STACK_DECORATION = <div className={CardViewStyles.ThumbnailWorkbookDecoration} />;

export class Thumbnail extends React.Component<ThumbnailProps, ThumbnailState> {
  private thumbnailImage: HTMLImageElement;
  private encodedSvg: string;

  constructor(props: ThumbnailProps) {
    super(props);
    this.state = { loadThumbnailImage: false };
    this.thumbnailImage = new Image();
    this.encodedSvg = '';
  }

  public componentDidMount() {
    this.calculateThumbnailImageUrl();
  }

  public componentDidUpdate() {
    this.calculateThumbnailImageUrl();
  }

  public componentWillUnmount() {
    this.thumbnailImage.onload = null;
  }

  private buildThumbnailOverlayDiv(): JSX.Element {
    return <div data-tb-test-id={ThumbnailOverlayTestID} style={{ display: 'none' }}></div>;
  }

  public render() {
    const notPreloadedClassNames = CardViewStyles.Thumbnail;
    const classNames = this.state.loadThumbnailImage ? [CardViewStyles.ThumbnailPreloaded] : [notPreloadedClassNames];
    const imageUri = this.props.useBase64EncodedImage ? `data:image/svg+xml;base64,${this.encodedSvg}` : this.props.thumbnailImageUrl;
    const backgroundImageUrl = this.state.loadThumbnailImage ? imageUri : this.props.defaultImageUrl;
    const loadedImageOrCoverBackground = this.props.imageCoverBackground || this.state.loadThumbnailImage;

    const thumbnailStyle: React.CSSProperties = {
      backgroundImage: `url(${backgroundImageUrl})`,
      backgroundSize: loadedImageOrCoverBackground ? 'cover' : '',
    };

    return (
      <a
        href={this.props.navigateUrl}
        data-tb-test-id={ThumbnailTestID}
        className={[Layout.relative, 'thumbnail-link'].join(' ')}
        onClick={this.props.onResultItemSelected}
        aria-label={this.props.ariaLabel}
      >
        <div className={classNames.join(' ')} style={thumbnailStyle} title={this.props.name} role="presentation">
          {this.buildThumbnailOverlayDiv()}
        </div>
        {this.props.decorate && CARD_STACK_DECORATION}
      </a>
    );
  }

  private calculateThumbnailImageUrl() {
    if (this.props.thumbnailImageUrl && !this.state.loadThumbnailImage) {
      if (this.props.useBase64EncodedImage) {
        this.encodedSvg = this.props.thumbnailImageUrl;
        this.setState({ loadThumbnailImage: true });
      } else {
        this.thumbnailImage.src = this.props.thumbnailImageUrl;
        this.thumbnailImage.onload = () => {
          this.setState({ loadThumbnailImage: true });
        };
      }
    }
  }
}
